import React, { useEffect, useRef, useState } from "react";
import { Timer, Play, RotateCcw } from "lucide-react";
import { useLang } from "../i18n";

function parseSeconds(rest) {
  if (rest == null) return 60;
  const s = String(rest).toLowerCase();
  const nums = s.match(/\d+/g);
  if (!nums) return 60;
  if (s.includes("min") || s.includes("'")) {
    const m = parseInt(nums[0], 10);
    const sec = nums[1] ? parseInt(nums[1], 10) : 0;
    return m * 60 + sec;
  }
  return parseInt(nums[0], 10);
}

const fmt = (t) => `${Math.floor(t / 60)}:${String(t % 60).padStart(2, "0")}`;

function playBeep() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const beepAt = (start, freq) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, start);
      gain.gain.exponentialRampToValueAtTime(0.25, start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.22);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(start);
      osc.stop(start + 0.24);
    };
    const now = ctx.currentTime;
    beepAt(now, 880);
    beepAt(now + 0.3, 1175);
    setTimeout(() => ctx.close(), 800);
  } catch (e) { /* audio not available */ }
}

export function RestTimer({ rest, color = "#3F6E85" }) {
  const { t } = useLang();
  const total = parseSeconds(rest);
  const [left, setLeft] = useState(null);
  const ref = useRef(null);

  useEffect(() => () => clearInterval(ref.current), []);

  const start = () => {
    clearInterval(ref.current);
    setLeft(total);
    ref.current = setInterval(() => {
      setLeft((v) => {
        if (v <= 1) { clearInterval(ref.current); playBeep(); return 0; }
        return v - 1;
      });
    }, 1000);
  };
  const reset = () => { clearInterval(ref.current); setLeft(null); };

  if (left === null) {
    return (
      <button onClick={start} data-testid="rest-timer-start"
        className="inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold transition-transform hover:scale-105"
        style={{ backgroundColor: `${color}18`, color }} title={t("rest_timer")}>
        <Timer className="w-3.5 h-3.5" /> {rest ?? "—"}
      </button>
    );
  }
  return (
    <button onClick={left === 0 ? reset : reset} data-testid="rest-timer-running"
      className="inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-bold text-white transition-transform hover:scale-105"
      style={{ backgroundColor: color }}>
      {left === 0 ? <RotateCcw className="w-3.5 h-3.5" /> : <Play className="w-3.5 h-3.5" />} {left === 0 ? t("rest_done") : fmt(left)}
    </button>
  );
}
